/* ==========================================================================
   PDP V2 — Trusted-Shops-Daten fuer Hero-Kasten und Sternezeile

   Holt die Produktbewertungen aus dem oeffentlichen eTrusted-Feed und
   schreibt daraus zwei Dinge in die Seite:

     1. KENNZAHLEN – Durchschnittsnote, Anzahl und die drei Sternebalken.
        Sie standen vorher als feste Werte in den Section-Einstellungen und
        liefen damit still aus dem Tritt, sobald neue Bewertungen kamen.
        Grundlage sind ALLE Bewertungen der SKU-Gruppe, also dieselbe
        Menge, die das Trusted-Shops-Widget weiter unten aggregiert.

     2. DIE DREI NEUESTEN Bewertungen mit Text und Bestnote im Hero-Kasten.

   ALLE SKUs, NICHT NUR DIE ERSTE. Das <etrusted-widget> fuehrt eine ganze
   SKU-Liste (bei ZeolithMED elf Stueck). Eine fruehere Fassung brach ab,
   sobald die erste SKU drei Treffer geliefert hatte – gemeint als Sparen
   von Requests, in Wahrheit ein Fehler: die erste SKU (Z200DE) hat 217
   Bewertungen, Z400DE dagegen 2022. Angezeigt wurden dadurch die neuesten
   Bewertungen EINER beliebigen SKU, nicht die neuesten ueberhaupt.

   ZWEI AUSWERTUNGEN aus denselben Daten: die Kennzahlen rechnen ueber ALLE
   Bewertungen (sonst waere der Schnitt geschoent), die drei Zitate dagegen
   nur ueber die mit Text und mindestens MIN_STERNE. Ohne diesen Filter
   stand im Kasten zeitweise eine 2-Sterne-Bewertung, weil sie zufaellig
   die drittneueste mit Text war.

   KEIN SCRAPING des Widgets: dessen Markup liegt hinter einer eigenen
   Komponente und wird erst nach Zustimmung geladen. Der Feed ist die
   stabilere Quelle – und es ist derselbe, aus dem das Widget rechnet.

   SELBSTKONFIGURIEREND – keine ID ist hier fest verdrahtet:
     Widget-ID + SKU-Liste  <- Attribute des <etrusted-widget>
     Channel-ID             <- /manifests/v1/<widgetId>.json, reference.id

   FEHLERFALL: schlaegt etwas fehl, bleibt alles so stehen, wie Liquid es
   gerendert hat – also die gepflegten Werte und das statische Zitat.
   ========================================================================== */
(function () {
  'use strict';

  var ANZAHL = 3;
  var MIN_STERNE = 5;
  var OHNE_ANTWORT = false;
  var BASIS = 'https://integrations.etrusted.com';

  /* Beschriftungen aus Liquid. Fehlt das Attribut - etwa weil eine aeltere
     Bewertungen-Section im Template steht - bleibt es beim deutschen Text. */
  var LABELS = (function () {
    var el = document.querySelector('[data-pdp2-review-labels]');
    if (!el) return {};
    try { return JSON.parse(el.getAttribute('data-pdp2-review-labels')) || {}; }
    catch (e) { return {}; }
  })();

  var sprache = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2);

  function hexSku(sku) {
    var out = '';
    for (var i = 0; i < sku.length; i++) {
      var h = sku.charCodeAt(i).toString(16);
      out += (h.length < 2 ? '0' : '') + h;
    }
    return out;
  }

  function zahl(n) {
    try { return n.toLocaleString(sprache); } catch (e) { return String(n); }
  }

  function note(n) {
    try {
      return n.toLocaleString(sprache, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) { return n.toFixed(2); }
  }

  /* Ersetzt die Zahl am Anfang eines Textes und laesst den Rest stehen.
     "30.500+ Bewertungen" -> "2.982 Bewertungen", und in der Sternezeile
     bleibt das angehaengte "· Alle ansehen" erhalten. So muss hier weder
     das Wort "Bewertungen" noch der Zusatz hartkodiert werden – beides
     kommt weiterhin aus den Section-Einstellungen und stimmt damit auch
     auf der italienischen und spanischen Seite. */
  function zahlErsetzen(el, neueZahl) {
    if (!el) return;
    var alt = (el.textContent || '').trim();
    var rest = alt.replace(/^[\d., \s]*\+?\s*/, '');
    el.textContent = rest ? (neueZahl + ' ' + rest) : neueZahl;
  }

  function kennzahlenSchreiben(stat) {
    var wurzeln = document.querySelectorAll('.pdp2');
    Array.prototype.forEach.call(wurzeln, function (wurzel) {
      // Durchschnittsnote: im Hero-Kasten und in der Sternezeile
      Array.prototype.forEach.call(wurzel.querySelectorAll('.grm-num'), function (el) {
        el.textContent = note(stat.schnitt);
      });
      Array.prototype.forEach.call(wurzel.querySelectorAll('.reviews-row > b'), function (el) {
        el.textContent = note(stat.schnitt);
      });

      // Anzahl: Kasten und Sternezeile, Rest des Textes bleibt stehen
      Array.prototype.forEach.call(wurzel.querySelectorAll('.grm-count'), function (el) {
        zahlErsetzen(el, zahl(stat.anzahl));
      });
      Array.prototype.forEach.call(wurzel.querySelectorAll('.reviews-row .count'), function (el) {
        zahlErsetzen(el, zahl(stat.anzahl));
      });

      // Balken 5/4/3 Sterne in genau dieser Reihenfolge
      var balken = wurzel.querySelectorAll('.grm-bars .grm-bar-fill');
      var reihe = [stat.prozent[5], stat.prozent[4], stat.prozent[3]];
      Array.prototype.forEach.call(balken, function (el, i) {
        if (reihe[i] === undefined) return;
        el.style.width = reihe[i] + '%';
      });
    });
  }

  function auswerten(alle) {
    var summe = 0;
    var verteilung = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    alle.forEach(function (rev) {
      var r = rev && rev.rating;
      if (typeof r !== 'number') return;
      summe += r;
      var stufe = Math.round(r);
      if (verteilung[stufe] !== undefined) verteilung[stufe]++;
    });
    var n = alle.length;
    var prozent = {};
    [1, 2, 3, 4, 5].forEach(function (s) {
      prozent[s] = n ? Math.round(verteilung[s] / n * 100) : 0;
    });
    return { anzahl: n, schnitt: n ? summe / n : 0, verteilung: verteilung, prozent: prozent };
  }

  function autor(rev) {
    var c = rev.consumer;
    if (!c) return null;
    var n = [c.firstName, c.lastName].filter(Boolean).join(' ').trim();
    return n || null;
  }

  function zeichne(box, reviews) {
    var liste = document.createElement('div');
    liste.className = 'grm-reviews';

    reviews.forEach(function (rev) {
      var art = document.createElement('article');
      art.className = 'grm-review';

      var kopf = document.createElement('div');
      kopf.className = 'grm-review-top';

      var n = Math.max(0, Math.min(5, Math.round(rev.rating || 0)));
      var sterne = document.createElement('span');
      sterne.className = 'grm-review-stars';
      sterne.textContent = new Array(n + 1).join('★');
      sterne.setAttribute('aria-label',
        (LABELS.starsOfFive || '__N__ von 5 Sternen').replace('__N__', n));
      kopf.appendChild(sterne);

      if (rev.isVerified) {
        var v = document.createElement('span');
        v.className = 'grm-review-verified';
        v.textContent = LABELS.verified || 'Verifiziert';
        kopf.appendChild(v);
      }
      art.appendChild(kopf);

      // textContent statt innerHTML: der Text stammt von Dritten.
      var txt = document.createElement('p');
      txt.className = 'grm-review-text';
      txt.textContent = rev.comment.trim();
      art.appendChild(txt);

      var meta = document.createElement('div');
      meta.className = 'grm-review-meta';
      var datum = '';
      try { if (rev.submittedAt) datum = new Date(rev.submittedAt).toLocaleDateString(sprache); }
      catch (e) { datum = ''; }
      meta.textContent = [autor(rev), datum].filter(Boolean).join(' · ');
      if (meta.textContent) art.appendChild(meta);

      liste.appendChild(art);
    });

    var alt = box.querySelector('.grm-quote');
    if (alt && alt.parentNode) alt.parentNode.replaceChild(liste, alt);
    else {
      var link = box.querySelector('.grm-link');
      if (link) box.insertBefore(liste, link); else box.appendChild(liste);
    }
  }

  function start() {
    if (document.documentElement.dataset.pdp2TsInit === '1') return;

    var widget = document.querySelector('etrusted-widget[data-etrusted-widget-id]');
    if (!widget) return;

    var widgetId = widget.getAttribute('data-etrusted-widget-id');
    var skus = (widget.getAttribute('data-sku') || '').split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);
    if (!widgetId || !skus.length) return;

    document.documentElement.dataset.pdp2TsInit = '1';

    fetch(BASIS + '/manifests/v1/' + widgetId + '.json')
      .then(function (r) { return r.json(); })
      .then(function (m) {
        var channelId = m && m.reference && m.reference.id;
        if (!channelId) throw new Error('keine Channel-ID im Manifest');

        /* Alle SKU-Feeds parallel. Ein fehlschlagender Feed liefert []
           und kippt nicht das Ganze. */
        return Promise.all(skus.map(function (sku) {
          var url = BASIS + '/feeds/product-reviews/v1/channels/' + channelId +
                    '/sku/' + hexSku(sku) + '/default/all/feed.json' +
                    '?widgetId=' + widgetId + '&channelId=' + channelId + '&showUGC=true';
          return fetch(url)
            .then(function (r) { return r.ok ? r.json() : []; })
            .catch(function () { return []; });
        }));
      })
      .then(function (feeds) {
        var alle = [];
        feeds.forEach(function (feed) {
          (Array.isArray(feed) ? feed : []).forEach(function (rev) {
            if (rev) alle.push(rev);
          });
        });
        if (!alle.length) return;

        // 1. Kennzahlen aus ALLEN Bewertungen
        kennzahlenSchreiben(auswerten(alle));

        // 2. Zitate nur aus Bewertungen mit Text und Bestnote
        var zitate = alle.filter(function (rev) {
          if (!rev.comment || !rev.comment.trim()) return false;
          if (MIN_STERNE && !(rev.rating >= MIN_STERNE)) return false;
          if (OHNE_ANTWORT && rev.reply) return false;
          return true;
        }).sort(function (a, b) {
          return new Date(b.submittedAt) - new Date(a.submittedAt);
        });

        if (!zitate.length) return;
        Array.prototype.forEach.call(
          document.querySelectorAll('.pdp2 .gallery-reviews-mini'),
          function (box) { zeichne(box, zitate.slice(0, ANZAHL)); }
        );
      })
      .catch(function () { /* still: gepflegte Werte bleiben stehen */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function () {
    // Im Theme-Editor wird eine Section neu gerendert: Werte neu setzen.
    delete document.documentElement.dataset.pdp2TsInit;
    start();
  });
})();
